// React
import { useQuery, keepPreviousData } from '@tanstack/react-query';

// API
import { getEvents, eventsQueryKeys, mapEventToListItem, type EventsListParams } from '@api/events';
import { ApiError } from '@api/client';

export function useEvents(params?: EventsListParams) {
  return useQuery({
    queryKey: eventsQueryKeys.list(params),
    queryFn: () => getEvents(params),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    select: (data) => ({
      events: data.events.map(mapEventToListItem),
      pagination: data.pagination,
      totalUnfiltered: data.total_unfiltered,
    }),
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
